<template>
  <table class="table">
    <thead>
      <tr>
        <th v-for="(item, index) in header" :key="index">{{ item }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, rowIndex) in data" :key="rowIndex">
        <td
          v-for="(column, columnIndex) in dataFields"
          :key="`${rowIndex}-${columnIndex}`"
        >
          <slot
            :name="column"
            v-if="column in $scopedSlots"
            v-bind="{ [column]: row[column], row }"
          />
          <span v-else>{{ row[column] }}</span>
        </td>
        <slot v-bind="row" v-if="!!$scopedSlots.default" />
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "table-data",

  props: {
    header: Array,
    data: Array,
    dataFields: Array
  }
};
</script>

<style></style>
